import styled from 'styled-components';

export const Container = styled.div`
  height: 107px;
  display: flex;
  align-items: center;
  overflow-x: auto;
  width: 100%;
`;

export const Thumbnail = styled.img`
  height: 74px;
  width: 74px;
  border-radius: 8px;
`;
export const InfoContainer = styled.div`
  border-left: 1px solid rgba(151, 151, 151, 0.17);
  height: 34px;
  padding: 0px 14px;
  display: flex;
  flex-direction: column;
  min-width: fit-content;
`;
export const TextContainer = styled.div`
  color: rgba(66, 72, 84, 1);
  font-family: 'Proxima Nova';
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.14px;
  line-height: 19px;
`;
export const TitleContainer = styled.div`
  color: rgba(93, 110, 129, 1);
  font-family: 'Proxima Nova';
  font-size: 12px;
  letter-spacing: 0.12px;
  line-height: 19px;
  margin-right: 4px;
`;
export const NameWrapper = styled.div`
  color: rgba(66, 72, 84, 1);
  font-family: 'Proxima Nova';
  font-size: 19px;
  font-weight: 500;
  letter-spacing: 0.19px;
  line-height: 19px;
`;
export const PersonalInfoWrapper = styled.div`
  padding: 14px;
  display: flex;
  flex-direction: column;
`;
export const LinearWrapper = styled.div`
  display: flex;
  & > :nth-child(2) {
    margin-right: 10px;
  }
`;
